module.exports = __webpack_public_path__ + "static/img/IMG_20160822_150214.f8aa6ce4.jpg";